// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"PageSidebar-sidebarContainer-3Hxpq","sidebar":"PageSidebar-sidebar-3IOcI"};